/** Numbers the dev overlay (and the benchmark script) read. Updated about twice a second. */
export interface PerfSnapshot {
  fps: number;
  /** Frames rendered in the last window (0 while an on-demand scene is idle). */
  frames: number;
  /** Draw calls of the scene itself (with its shadow maps), without the post-processing passes. */
  calls: number;
  triangles: number;
  /** Scene passes rendered so far; it moves with every new `calls`/`triangles` reading (tests wait on it). */
  drawn: number;
  /** Draw calls spent by post-processing (the ambient occlusion depth pass, bloom, filters). */
  postCalls: number;
  /** True while the post-processing pipeline renders the frame. */
  post: boolean;
  geometries: number;
  textures: number;
  frameloop: "always" | "demand";
}

export const perfSnapshot: PerfSnapshot = {
  fps: 0,
  frames: 0,
  calls: 0,
  triangles: 0,
  drawn: 0,
  postCalls: 0,
  post: false,
  geometries: 0,
  textures: 0,
  frameloop: "demand",
};
